module.exports = __webpack_public_path__ + "img/share.a79a70d4.png";